import { Link } from "react-router-dom";
import { Logo } from "../components/ui/Logo";

function Section({ n, title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-lg font-semibold tracking-tight text-[#1a4f8a] sm:text-xl">
        {n}. {title}
      </h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-slate-700 sm:text-base">{children}</div>
    </section>
  );
}

export default function Terminos() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-6 py-10 sm:px-10 sm:py-14 lg:px-12 lg:py-16">
        <div className="flex justify-start">
          <Link
            to="/"
            className="text-sm font-medium text-slate-600 underline-offset-2 transition-colors hover:text-[#1a4f8a] hover:underline"
          >
            ← Volver
          </Link>
        </div>

        <div className="mt-8 flex justify-center">
          <Logo variant="wordmark" format="png" size="md" className="max-h-14 sm:max-h-16" />
        </div>

        <header className="mt-10 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
            Términos y Condiciones de Uso
          </h1>
          <p className="mt-2 text-sm text-slate-500 sm:text-base">Última actualización: Mayo 2026</p>
        </header>

        <div className="mt-4 border-t border-slate-200 pt-2">
          <Section n={1} title="IDENTIFICACIÓN DEL TITULAR">
            <p>
              Aurora Geriátrica es una plataforma SaaS de tecnología médica desarrollada en Guatemala.
            </p>
            <p>
              Email:{" "}
              <a href="mailto:contacto@aurorageriatrica.com" className="font-medium text-[#1a4f8a] underline-offset-2 hover:underline">
                contacto@aurorageriatrica.com
              </a>
            </p>
            <p>
              Legal:{" "}
              <a href="mailto:legal@aurorageriatrica.com" className="font-medium text-[#1a4f8a] underline-offset-2 hover:underline">
                legal@aurorageriatrica.com
              </a>
            </p>
          </Section>

          <Section n={2} title="DESCRIPCIÓN DEL SERVICIO">
            <p>
              Aurora Geriátrica es una herramienta de apoyo clínico para evaluaciones geriátricas. NO sustituye el criterio
              médico profesional. La responsabilidad clínica recae exclusivamente en el profesional de salud.
            </p>
          </Section>

          <Section n={3} title="PROPIEDAD INTELECTUAL">
            <p>© 2026 Aurora Geriátrica. Todos los derechos reservados.</p>
            <p>
              El software, diseño, marca, escalas implementadas y documentos generados son propiedad exclusiva de Aurora
              Geriátrica. Prohibida la copia, ingeniería inversa o uso comercial sin autorización escrita.
            </p>
          </Section>

          <Section n={4} title="PROPIEDAD DE LOS DATOS CLÍNICOS">
            <p>
              Los datos de pacientes ingresados por el Médico son propiedad exclusiva del Médico Usuario. Aurora Geriátrica
              actúa únicamente como procesador técnico y NUNCA vende, comparte ni comercializa datos clínicos.
            </p>
          </Section>

          <Section n={5} title="RESPONSABILIDAD CLÍNICA">
            <p>
              El Médico asume plena responsabilidad profesional por las decisiones clínicas tomadas con apoyo de la plataforma,
              la exactitud de los datos ingresados y el uso apropiado de los documentos generados.
            </p>
          </Section>

          <Section n={6} title="SUSCRIPCIÓN Y PAGOS">
            <p>
              Plan LATAM: USD $39.00/mes. Cancelación en cualquier momento. Acceso hasta fin del período pagado. Sin
              reembolsos por períodos parciales salvo falla técnica.
            </p>
          </Section>

          <Section n={7} title="CANCELACIÓN Y DATOS">
            <p>Al cancelar: 30 días para exportar datos.</p>
            <p>A los 90 días: eliminación permanente de datos del servidor.</p>
            <p>
              Eliminación inmediata disponible escribiendo a{" "}
              <a href="mailto:legal@aurorageriatrica.com" className="font-medium text-[#1a4f8a] underline-offset-2 hover:underline">
                legal@aurorageriatrica.com
              </a>
            </p>
          </Section>

          <Section n={8} title="LEY APLICABLE">
            <p>Estos Términos se rigen por las leyes de la República de Guatemala. Jurisdicción: Ciudad de Guatemala.</p>
          </Section>
        </div>

        <footer className="mt-14 border-t border-slate-200 pt-8 text-center text-sm text-slate-600">
          <p className="font-medium text-slate-700">Documentos relacionados</p>
          <nav className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <Link to="/privacidad" className="text-[#1a4f8a] underline-offset-2 hover:underline">
              Política de Privacidad
            </Link>
            <span className="text-slate-300" aria-hidden>
              ·
            </span>
            <Link to="/datos" className="text-[#1a4f8a] underline-offset-2 hover:underline">
              Acuerdo de Datos Clínicos
            </Link>
          </nav>
        </footer>
      </div>
    </div>
  );
}
